import React from 'react';

const FileSearchRouteNavigationOptions = {
  headerShown: false
};

export default FileSearchRouteNavigationOptions; 